import { Box, Icon, Text, Link } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

const BANNER_FIELDS = [
  'missing_salary_code',
  'missing_legal_entity_mapping',
  'missing_leave_type_mapping',
]

interface Props {
  unavailable_fields: string[] | null
  isLeaveIncidence: boolean
}

const FieldDescription = ({
  field,
  settingsHref,
  isLeaveIncidence,
}: {
  field: string
  settingsHref: string
  isLeaveIncidence: boolean
}) => {
  if (field === 'missing_legal_entity_mapping') {
    return isLeaveIncidence
      ? i18n.t(
          'payroll_integrations.incidences.datev_lauds.absences.missing_leave_type_mapping.description'
        )
      : i18n.t('payroll_integrations.incidences.datev_lauds.hiring.missing_salary_code.description')
  }

  const settingsLink = (
    <Link.Href href={settingsHref} target="_blank" rel="nofollow noopener noreferrer">
      {field === 'missing_leave_type_mapping'
        ? i18n.t(
            'payroll_integrations.incidences.datev_lauds.absences.missing_leave_type_mapping.link'
          )
        : i18n.t('payroll_integrations.incidences.datev_lauds.hiring.missing_salary_code.link')}
    </Link.Href>
  )

  if (field === 'missing_leave_type_mapping') {
    return i18n.tView(
      'payroll_integrations.incidences.datev_lauds.absences.missing_leave_type_mapping.new_description',
      { link: settingsLink }
    )
  }

  return i18n.tView(
    'payroll_integrations.incidences.datev_lauds.hiring.missing_salary_code.new_description',
    { link: settingsLink }
  )
}

const MissingSalaryCode = ({ unavailable_fields, isLeaveIncidence }: Props) => {
  const { navigation } = useNavigation()
  const datevLaudsIntegrationDatoId = integrationCodes.datev_lauds_factorial
  const settingsHref = navigation.discover.marketplace.item.settings.fullPath({
    id: datevLaudsIntegrationDatoId,
  })

  return (unavailable_fields ?? [])
    .filter((field) => BANNER_FIELDS.includes(field))
    .map((field: string) => (
      <Box
        background="radicalRed200"
        paddingX="s24"
        paddingY="s16"
        borderRadius={{
          all: 'abs008',
        }}
        gap="s16"
        key={field}
      >
        <Box gap="s4" flexDirection="row">
          <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />

          <Text.Header2>{fieldTranslations.t(field)}</Text.Header2>
        </Box>
        <FieldDescription
          field={field}
          settingsHref={settingsHref}
          isLeaveIncidence={isLeaveIncidence}
        />
      </Box>
    ))
}

export default MissingSalaryCode
